module.exports = __webpack_public_path__ + "images/spin.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/spin.png
// module id = 5zD6
// module chunks = 55